"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyUserLibraryFeaturedV2 = void 0;
exports.userLibraryFeaturedV2SetMock = userLibraryFeaturedV2SetMock;
exports.userLibraryFeaturedV2 = userLibraryFeaturedV2;
exports.useQueryUserLibraryFeaturedV2 = useQueryUserLibraryFeaturedV2;
exports.useInfiniteQueryUserLibraryFeaturedV2 = useInfiniteQueryUserLibraryFeaturedV2;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function userLibraryFeaturedV2SetMock(mock) {
    setMock = mock;
}
async function userLibraryFeaturedV2(params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/wolf-athenaeum-service/v2/user-library/featured`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params)
        : client.getRequestConfig(params);
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    queryParams.softwareNumber = params.softwareNumber;
    queryParams.doEnableScaling = params.doEnableScaling;
    queryParams.trim = params.trim;
    queryParams.returnFields = params.returnFields;
    queryParams.membershipType = params.membershipType;
    queryParams.workoutFilters = params.workoutFilters;
    queryParams.category = params.category;
    if (params.etag !== undefined) {
        headers.etag = params.etag;
    }
    if (params['If-None-Match'] !== undefined) {
        headers['If-None-Match'] = params['If-None-Match'];
    }
    if (params['X-Llama-Namespaces'] !== undefined) {
        headers['X-Llama-Namespaces'] = params['X-Llama-Namespaces'];
    }
    if (params['X-Llama-Log-Level'] !== undefined) {
        headers['X-Llama-Log-Level'] = params['X-Llama-Log-Level'];
    }
    if (params['Cache-Control'] !== undefined) {
        headers['Cache-Control'] = params['Cache-Control'];
    }
    if (params.Accept !== undefined) {
        headers.Accept = params.Accept;
    }
    if ((client.statusChecksEnabled || params.forceStatusCheck) && (await (0, is_down_1.wolfAthenaeumServiceIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { headers, method: 'GET', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeyUserLibraryFeaturedV2 = 'wolf-athenaeum-service:userLibraryFeaturedV2:get';
function useQueryUserLibraryFeaturedV2(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyUserLibraryFeaturedV2, requestParams];
    return reactQuery.useQuery(key, queryFn, queryOptions);
}
function useInfiniteQueryUserLibraryFeaturedV2(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyUserLibraryFeaturedV2, requestParams];
    return reactQuery.useInfiniteQuery(key, queryFn, queryOptions);
}
function queryFn({ queryKey, pageParam }) {
    const [, params] = queryKey;
    const promise = userLibraryFeaturedV2(pageParam ? Object.assign(Object.assign({}, params), pageParam) : params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=user-library-featured-v2.js.map